import React from 'react';
import { CloseIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import ModalTemplate from '@components/modalTemplate';
import { useConfirmModal } from '@store/useConfirmModal';

export default function ConfirmModalComp() {
    const {
        isOpen,
        isLoading,
        title,
        desc,
        onSubmit,
        onClose,
        btnLabelNo,
        isShowBtnNo,
        btnLabelYes,
        ConfirmationStateImage,
        isDanger,
        reset,
    } = useConfirmModal();

    const onCloseHandler = () => {
        if (onClose) onClose();
        reset();
    };

    const onSubmitHandler = () => {
        if (onSubmit) onSubmit();
        reset();
    };

    return (
        <ModalTemplate isOpen={isOpen} width={'546px'} onClose={onCloseHandler} isClosebyOverlayClick={false}>
            <Box p={'12px 12px 28px'}>
                <Box px={'40px'} textAlign={'center'} position={'relative'}>
                    <Button onClick={onCloseHandler} variant={'unstyled'} position={'absolute'} right={'0'}>
                        <CloseIcon />
                    </Button>

                    {isLoading ? (
                        <Box>Loading...</Box>
                    ) : (
                        <>
                            <Flex justifyContent={'center'}>
                                <ConfirmationStateImage />
                            </Flex>
                            <Text fontWeight={'600'} fontSize={'24px'}>
                                {title}
                            </Text>
                            <Text mx={'auto'}>{desc}</Text>
                            <Flex gap={'12px'} justifyContent={'center'} mt={'40px'}>
                                {isShowBtnNo && (
                                    <Button onClick={onCloseHandler} variant="outline" px={'52px'}>
                                        {btnLabelNo}
                                    </Button>
                                )}
                                <Button
                                    onClick={onSubmitHandler}
                                    px={'52px'}
                                    colorScheme={isDanger ? 'danger' : 'paragon'}
                                >
                                    {btnLabelYes}
                                </Button>
                            </Flex>
                        </>
                    )}
                </Box>
            </Box>
        </ModalTemplate>
    );
}
